import React, { useContext, useRef, useEffect } from 'react';

import DisplayContext from '../../../UtilityComponents/displayContext';
import { ResponsiveContainer, Heading, FlexDiv, GenericP } from '../../../common/Styles';
import * as S from './DownloadSectionStyle';
import { loadNextComponent, trackClickEvents } from '../../utils';
import { landingImgPath, mobileLandingImgPath, DownloadSectionData } from '../../config';
import { ADOBE_EVENT_VALUES } from 'AppConstants';

const DownloadSection = ({ showNextComp, nextComp, prevComp, app = {} }) => {
	const refHtml = useRef();
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = displayName == 'mobile';
	const imgPath = isMobile ? mobileLandingImgPath : landingImgPath;
	const { heading, subHeading, actionContent } = DownloadSectionData;

	const { qrCode = landingImgPath + 'qrcode.png', andriod, ios } = app;

	const openAppLink = (type) => (e) => {
		e.preventDefault();
		let link = andriod;
		if (type === 'ios') {
			link = ios;
		}
		trackClickEvents(ADOBE_EVENT_VALUES.LANDING?.[type.toUpperCase()]);
		window.location = link;
	};

	useEffect(() => {
		loadNextComponent(refHtml, showNextComp, nextComp, prevComp);
	}, []);

	return (
		<S.Container as='section' ref={refHtml} top_M='102'>
			<ResponsiveContainer
				isFlex='true'
				mobileDir='column'>
				<FlexDiv $width={`${isMobile ? '100%' : '40%'}`} max_height='533px'>
					<img
						crossOrigin='anonymous'
						height={isMobile ? '277' : '479'}
						width={isMobile ? '320' : '464'}
						loading='lazy'
						src={`${imgPath}dashboardImg.png`} alt='dashboard image'
					/>
				</FlexDiv>
				<S.DownloadSectionRightWrap>
					<Heading as='h3' font_size={`${isMobile ? '28' : '48'}`} marBt='16px'>
						{heading}
					</Heading>
					<GenericP fsize={isMobile ? '14px' : '22px'}>
						{subHeading}
					</GenericP>
					<S.QrCodeText>{actionContent}</S.QrCodeText>
					<FlexDiv justify='fex-start' directionInMobile='column'>
						<FlexDiv $width={isMobile ? '100%' : '45%'} bottom_M={isMobile ? '20' : '0'} justify='fex-start'>
							<img crossOrigin='anonymous' width='200' height='200' loading='lazy' src={qrCode} alt='scan qr code to install app' />
						</FlexDiv>
						<S.AppDownloadBtnWrapper>
							<div>
								<a href={andriod} onClick={openAppLink('android')}>
									<img crossOrigin='anonymous' width='172' height='49' loading='lazy' src={imgPath + 'androidlink.png'} alt='android app link' />
								</a>
							</div>
							<div>
								<a onClick={openAppLink('ios')} href={ios}>
									<img crossOrigin='anonymous' width='172' height='49' loading='lazy' src={imgPath + 'applelink.png'} alt='ios app link' />
								</a>
							</div>
						</S.AppDownloadBtnWrapper>
					</FlexDiv>
				</S.DownloadSectionRightWrap>
			</ResponsiveContainer>
		</S.Container>
	);
};

export default DownloadSection;
